import { useEffect } from 'react';

import { useUserActions } from 'src/contexts/UserContext';

export const LogOut: React.FC = () => {
  const { logOut: doLogOut } = useUserActions();
  useEffect(doLogOut, [doLogOut]);
  return null;
};
